import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';

import { Contact } from '../models/contact';

@Component({
  selector: 'app-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss'],
})
export class ContactCardComponent implements OnInit {

  @Input() contactToView?: Contact;
  @ViewChild('childComponentTemplate', { static: true }) childComponentTemplate: TemplateRef<any>;

  constructor() { }

  ngOnInit() {
    console.log(this.contactToView);
  }

}